export const mysqlDateFormat = 'YYYY-MM-DD';
export const mysqlDateTimeFormat = 'YYYY-MM-DD hh:mm:ss';
export const dateTimeShortFormat = 'M/D/YY, h:mm A';
export const dateTimeLongFormat = 'dddd, MMMM Do YYYY h:mm A';
export const dateLongFormat = 'dddd, MMMM Do YYYY'
export const dateShortFormat = 'M/D/YY';
export const timestampFormat = 'X';
